// extracted by mini-css-extract-plugin
export default {"conteiner":"SearchBar_conteiner__ZEXR6"};